import NavMenu from "../../navMenu.js";

export default (el, index) => {
  const globalHeaderMobile = document.querySelector(".global-header__mobile");
  const isMobile = globalHeaderMobile.contains(el);
  const headerEl = document.querySelector("header");
  const bodyEl = document.querySelector("body");

  const onClose = () => {
    if (isMobile) {
      headerEl.style.position = "";
      headerEl.style.top = "";
      headerEl.style.zIndex = "";
      bodyEl.style.overflow = "";
    }
  };

  const onOpen = () => {
    if (isMobile) {
      headerEl.style.position = "sticky";
      headerEl.style.top = "0";
      headerEl.style.zIndex = "3";
      bodyEl.style.overflow = "hidden";
    }
  };

  NavMenu({
    animationDelay: 500,
    closed: true,
    direction: "vertical",
    menuButton: ".js-search-menu-button",
    menuContainer: ".js-search-menu-content",
    navigationLink: "input",
    openClass: "is-open",
    onClose: onClose,
    onOpen: onOpen,
    parent: el,
  });
};
